"use client";

import {
  CredentialResponse,
  GoogleLogin,
  type GoogleLoginProps,
} from "@react-oauth/google";
import { Loader2 } from "lucide-react";
import { RefObject } from "react";

import { authTestIds } from "@/lib/data-test-ids/components.data-test-ids";

interface GoogleSignInButtonViewProps {
  containerRef: RefObject<HTMLDivElement | null>;
  buttonWidth: number;
  isAuthenticating: boolean;
  onSuccess: (credentialResponse: CredentialResponse) => void;
  onError: () => void;
  text: GoogleLoginProps["text"];
}

export default function GoogleSignInButtonView({
  containerRef,
  buttonWidth,
  isAuthenticating,
  onSuccess,
  onError,
  text,
}: GoogleSignInButtonViewProps) {
  return (
    <div ref={containerRef} className="w-full">
      <div className="relative">
        <GoogleLogin
          onSuccess={onSuccess}
          onError={onError}
          theme="outline"
          size="large"
          text={text}
          width={buttonWidth}
          locale="en"
          data-testid={authTestIds.GOOGLE_BUTTON}
        />
        {isAuthenticating && (
          <div
            className="absolute inset-0 flex items-center justify-center bg-card/80 rounded-lg"
            style={{ pointerEvents: "none" }}
          >
            <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />
          </div>
        )}
      </div>
    </div>
  );
}
